import { rest } from 'msw';
import {
  personMocked,
} from './mock-data';

export const handlers = [
  // Handles a GET /user request
  rest.get('/web-apis/get-customer', (req, res, ctx) => {
    if (req.url.search === '?id=-1') {
      return res(
        ctx.status(404),
        ctx.json({
          errorMessage: 'Record not found',
        }),
      );
    }
    return res(ctx.delay(2000), ctx.status(200), ctx.json(personMocked));
  }),
];
